import React, { useEffect, useCallback } from "react";
import { useState } from "react";
import UserNavbar from "../UserNavbar";
import UserFooter from "../UserFooter";
import MainSidebar from "../Mainsidebar";
import { Formik, Field, useFormik, useFormikContext } from "formik";
import axios from "axios";
import "../../Style/NewCustomer.css";
import "react-toastify/dist/ReactToastify.css";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { path_url } from "../../Config/config";
import SpeechToText from "../../AI/SpeechToText";
import EventDialog from "../components/EventDialog";
import { useParams, useNavigate } from "react-router-dom";
import { Link, Outlet } from "react-router-dom";
import CsvImport from "./CsvImport";
import { Modal } from "@mui/material";
import { useCurrentUser } from "../../context/UserContext";
import { isUUID } from "../../Utils/auth";
// import "../Style/LandingPage.css";
//import { useParams } from "react-router-dom";

const AutoSyncShipping = ({ values, setFieldValue }) => {
  const prevCheckedRef = React.useRef(values.copyBillingToShipping);

  React.useEffect(() => {
    const isChecked = values.copyBillingToShipping;
    const wasChecked = prevCheckedRef.current;

    if (isChecked) {
      // Sync on check or on billing address change
      setFieldValue("shippingAddress.address1", values.billingAddress.address1);
      setFieldValue("shippingAddress.address2", values.billingAddress.address2);
      setFieldValue("shippingAddress.city", values.billingAddress.city);
      setFieldValue("shippingAddress.pincode", values.billingAddress.pincode);
      setFieldValue("shippingAddress.state", values.billingAddress.state);
      setFieldValue("shippingAddress.country", values.billingAddress.country);
    } else if (wasChecked && !isChecked) {
      // Clear on uncheck
      setFieldValue("shippingAddress.address1", "");
      setFieldValue("shippingAddress.address2", "");
      setFieldValue("shippingAddress.city", "");
      setFieldValue("shippingAddress.pincode", "");
      setFieldValue("shippingAddress.state", "");
      setFieldValue("shippingAddress.country", "");
    }
    prevCheckedRef.current = isChecked;
  }, [
    values.copyBillingToShipping,
    values.billingAddress.address1,
    values.billingAddress.address2,
    values.billingAddress.city,
    values.billingAddress.pincode,
    values.billingAddress.state,
    values.billingAddress.country,
    setFieldValue,
  ]);
  return null;
};

export default function NewCustomer() {
  const { currentUser } = useCurrentUser();
  const [showEventDialog, setShowEventDialog] = useState(false);
  const [hamburger, sethamburger] = useState(false);
  const [isRightMenu, setisRightMenu] = useState(true);
  const [isSearchShow, setIsSearchShow] = useState(false);
  const [fullScreen, setFullScreen] = useState(true);
  // To track e
  const [isModalOpen, setIsModalOpen] = useState(true);

  const [showModal, setShowModal] = useState(false);
  const [upddata, setupdData] = useState([]);
  const handleScreenEnter = () => {
    setFullScreen(false);
    document.body.requestFullscreen();
  };
  const handleScreenExit = () => {
    setFullScreen(true);
    document.exitFullscreen();
  };
  const handelShow = () => setIsSearchShow(!isSearchShow);
  const handelRightMenuShow = () => setisRightMenu(!isRightMenu);
  const handleclickonbutton = (hamburger) => {
    if (document.documentElement.clientWidth <= 800)
      return { width: "100%", left: "0rem" };
    else
      return {
        width: !hamburger && "-webkit-fill-available",
        left: !hamburger && "3.7rem",
      };
  };
  const handleclickonbutton1 = (hamburger) => {
    if (document.documentElement.clientWidth <= 800) {
      return { display: hamburger && "none" };
    }
  };
  const options = [
    { value: "Phone", label: "Phone" },
    { value: "Email", label: "Email" },
  ];
  const Enum = [
    { value: "OPEN", label: "Open" },
    { value: "ATTEMPTEDCONTACT", label: "Attempted Contact" },
    { value: "NOTENGAGED", label: "Not Engaged" },
    { value: "NEEDSFOLLOWUP", label: "Needs Follow Up" },
    { value: "WORKING", label: "Working" },
    { value: "NEWOPPORTUNITY", label: "New Opportunity" },
    { value: "QUALIFIED", label: "Qualified" },
    { value: "CONVERTTOCUSTOMER", label: "Convert To Customer" },
    { value: "DISQUALIFIED", label: "Disqualified" },
  ];
  const copyBillingToShipping = (formik) => {
    const { address1, address2, city, pincode, state, country } =
      formik.values.billingAddress;
    formik.setFieldValue("shippingAddress.address1", address1);
    formik.setFieldValue("shippingAddress.address2", address2);
    formik.setFieldValue("shippingAddress.city", city);
    formik.setFieldValue("shippingAddress.pincode", pincode);
    formik.setFieldValue("shippingAddress.state", state);
    formik.setFieldValue("shippingAddress.country", country);
  };

  function transformData(values, id) {
    const validUserCid = [values.usercid, currentUser?.id, localStorage.getItem("userId"), localStorage.getItem("adminId")].find(val => isUUID(val)) || null;
    const validAdminId = [values.useradminid, currentUser?.useradminid, currentUser?.id, localStorage.getItem("adminId"), validUserCid].find(val => isUUID(val)) || null;

    const payload = {
      customer: {
        readstatus: "OPEN",
        companyname: values.companyname,
        firstname: values.firstname,
        lastname: values.lastname,
        leadsource: values.leadsource,
        status: values.status === "WORKING" ? "OPEN" : values.status || "OPEN",
        website: values.website,
        bestwaycontact: values.bestwaycontact,
        mobile: values.mobile,
        altphone: values.altphone,
        email: values.email,
        notes: values.notes,
        product: values.product,
        usercid: validUserCid,
        useradminid: validAdminId,
        owner: validUserCid || validAdminId,
      },
      billingAddress: {
        active: true,
        name: "Billing Address",
        state: values.billingAddress.state,
        country: values.billingAddress.country,
        address1: values.billingAddress.address1,
        address2: values.billingAddress.address2,
        pincode: values.billingAddress.pincode,
        city: values.billingAddress.city,
        usercid: validUserCid,
        useradminid: validAdminId,
      },
      shippingAddress: {
        active: true,
        name: "Shipping Address",
        state: values.shippingAddress.state,
        country: values.shippingAddress.country,
        address1: values.shippingAddress.address1,
        address2: values.shippingAddress.address2,
        pincode: values.shippingAddress.pincode,
        city: values.shippingAddress.city,
        usercid: validUserCid,
        useradminid: validAdminId,
      },
    };

    if (id) {
      payload.customer.id = id;
    }

    return payload;
  }

  const [sourceData, setSourceData] = useState([]);
  const token = localStorage.getItem("accessToken");

  useEffect(() => {
    const fetchSourceData = async () => {
      try {
        const token = localStorage.getItem("accessToken");
        const adminId = currentUser?.useradminid || currentUser?.id || null;
        if (!adminId || !isUUID(adminId)) {
          // adminId not yet loaded or is not a UUID — skip this call silently
          return;
        }
        const config = {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        };

        const response = await axios.get(
          `${path_url}/events/source/archon/${adminId}`,
          config,
        );

        const data = response.data.body;
        setSourceData(data);
      } catch (error) {
        console.error("Error fetching source data:", error);
      }
    };
    fetchSourceData();
  }, [currentUser]);

  const defaultSourceOptions = [
    "Website",
    "Referral",
    "Social Media",
    "Email Campaign",
    "Trade Show",
    "Cold Call",
    "Walk-in",
    "Partner Program",
    "Other",
  ];
  const handleModal = () => {
    setIsModalOpen(!isModalOpen);
  };

  const { id } = useParams();
  const navigate = useNavigate();
  const [initialData, setInitialData] = useState(null);

  useEffect(() => {
    if (id) {
      const fetchCustomer = async () => {
        try {
          const token = localStorage.getItem("accessToken");
          const res = await axios.get(`${path_url}/customer/${id}`, {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });

          // Check if response is wrapped in a body field
          const data = res.data.body ? res.data.body : res.data;
          setInitialData(data);
        } catch (err) {
          console.log(err.message);
        }
      };
      fetchCustomer();
    }
  }, [id]);
  return (
    <>
      <div className="con1 d-flex">
        <div className="subcon1" style={handleclickonbutton1(hamburger)}>
          <MainSidebar hamburger={hamburger} sethamburger={sethamburger} />
        </div>
        <div className="subcon2" style={handleclickonbutton(hamburger)}>
          <UserNavbar
            hamburger={hamburger}
            sethamburger={sethamburger}
            isRightMenu={isRightMenu}
            handelRightMenuShow={handelRightMenuShow}
            handelShow={handelShow}
            isSearchShow={isSearchShow}
            handleScreenEnter={handleScreenEnter}
            handleScreenExit={handleScreenExit}
            fullScreen={fullScreen}
          />
          <div className="mt-2">
            <Formik
              enableReinitialize={true}
              key={JSON.stringify(initialData)}
              initialValues={{
                readstatus: initialData?.customer?.readstatus || "..",
                firstname: initialData?.customer?.firstname || "",
                lastname: initialData?.customer?.lastname || "",
                companyname: initialData?.customer?.companyname || "",
                mobile: initialData?.customer?.mobile || "",
                altphone: initialData?.customer?.altphone || "",
                email: initialData?.customer?.email || "",
                website: initialData?.customer?.website || "",
                billingAddress: {
                  address1: initialData?.billingAddress?.address1 || "",
                  address2: initialData?.billingAddress?.address2 || "",
                  city: initialData?.billingAddress?.city || "",
                  pincode: initialData?.billingAddress?.pincode || "",
                  state: initialData?.billingAddress?.state || "",
                  country: initialData?.billingAddress?.country || "",
                },
                shippingAddress: {
                  address1: initialData?.shippingAddress?.address1 || "",
                  address2: initialData?.shippingAddress?.address2 || "",
                  city: initialData?.shippingAddress?.city || "",
                  pincode: initialData?.shippingAddress?.pincode || "",
                  state: initialData?.shippingAddress?.state || "",
                  country: initialData?.shippingAddress?.country || "",
                },
                copyBillingToShipping: false,
                notes: initialData?.customer?.notes || "",
                bestwaycontact: initialData?.customer?.bestwaycontact || "",
                leadsource: initialData?.customer?.leadsource || "",
                status: initialData?.customer?.status || "",
                product: initialData?.customer?.product || "Cosmetic",
                usercid: initialData?.customer?.usercid || currentUser?.id || localStorage.getItem("userId") || localStorage.getItem("adminId"),
                useradminid: initialData?.customer?.useradminid || currentUser?.useradminid || currentUser?.id || localStorage.getItem("adminId"),
                owner: initialData?.customer?.owner || currentUser?.useradminid || currentUser?.id || localStorage.getItem("adminId"),
              }}
              onSubmit={async (values) => {
                try {
                  const nameRegex = /^[a-zA-Z\s]{2,}$/;
                  const phoneNumberRegex = /^\d{10,15}$/;
                  const pincodeRegex = /^\d{6}$/;
                  const stateCountryRegex = /^[a-zA-Z\s]+$/;
                  const emailRegex =
                    /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                  const addressRegex = /^[a-zA-Z0-9\s,.-]+$/;

                  const errors = [];
                  const req = [];
                  if (!values.firstname) {
                    req.push("Name");
                  }
                  if (!values.mobile) {
                    req.push("Phone number");
                  }
                  if (!values.email) {
                    req.push("Email address");
                  }

                  // Validate mandatory fields
                  if (
                    (values.firstname && !nameRegex.test(values.firstname)) ||
                    (values.lastname && !nameRegex.test(values.lastname))
                  ) {
                    errors.push("Name");
                  }
                  if (values.mobile && !phoneNumberRegex.test(values.mobile)) {
                    errors.push("Phone number");
                  }
                  if (values.email && !emailRegex.test(values.email)) {
                    errors.push("Email address");
                  }

                  if (
                    values.billingAddress?.pincode &&
                    !pincodeRegex.test(values.billingAddress.pincode)
                  ) {
                    errors.push("Pincode");
                  }
                  if (
                    values.billingAddress?.state &&
                    !stateCountryRegex.test(values.billingAddress.state)
                  ) {
                    errors.push("State name");
                  }
                  if (
                    values.billingAddress?.country &&
                    !stateCountryRegex.test(values.billingAddress.country)
                  ) {
                    errors.push("Country name");
                  }
                  if (
                    values.billingAddress?.address1 &&
                    !addressRegex.test(values.billingAddress.address1)
                  ) {
                    errors.push("Address format");
                  }

                  if (!values.status) {
                    values.status = "OPEN";
                  }

                  if (req.length > 0) {
                    const reqMessage = req.join(", ") + " is required";
                    toast.error(reqMessage);
                  } else if (errors.length > 0) {
                    const errorMessage = "Invalid " + errors.join(", ");
                    toast.error(errorMessage);
                  } else {
                    const token = localStorage.getItem("accessToken");
                    let response;

                    if (id) {
                      // UPDATE: PUT /customer/update expects a flat Customer object
                      const updatePayload = {
                        id: id,
                        readstatus: "OPEN",
                        companyname: values.companyname,
                        firstname: values.firstname,
                        lastname: values.lastname,
                        leadsource: values.leadsource,
                        status: values.status === "WORKING" ? "OPEN" : values.status || "OPEN",
                        website: values.website,
                        bestwaycontact: values.bestwaycontact,
                        mobile: values.mobile,
                        altphone: values.altphone,
                        email: values.email,
                        notes: values.notes,
                        product: values.product,
                        usercid: values.usercid || localStorage.getItem("adminId"),
                        useradminid: values.useradminid || localStorage.getItem("adminId"),
                        owner: values.owner,
                      };

                      response = await axios.put(
                        `${path_url}/customer/update`,
                        updatePayload,
                        {
                          headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                          },
                        },
                      );
                    } else {
                      // CREATE: POST /customer expects nested CustomerRequest
                      const submitPayload = transformData(values, id);

                      response = await axios.post(
                        `${path_url}/customer`,
                        submitPayload,
                        {
                          headers: {
                            Authorization: `Bearer ${token}`,
                            "Content-Type": "application/json",
                          },
                        },
                      );
                    }

                    if (
                      response &&
                      (response.data.statusCodeValue === 200 ||
                        response.status === 200 ||
                        response.status === 201)
                    ) {
                      toast.success(
                        id
                          ? "Customer updated successfully"
                          : "Form submitted successfully",
                      );
                      setTimeout(() => {
                        navigate(-1);
                      }, 1000);
                    } else if (response) {
                      toast.error(
                        response.data?.body || "Failed to submit form",
                      );
                    }
                  }
                } catch (error) {
                  console.error("Submit error:", error);
                  if (
                    error.response &&
                    error.response.data &&
                    error.response.data.message
                  ) {
                    toast.error(error.response.data.message);
                  } else {
                    toast.error("Failed to save customer. Please try again.");
                  }
                }
              }}
            >
              {(formik) => (
                <form onSubmit={formik.handleSubmit}>
                  <AutoSyncShipping
                    values={formik.values}
                    setFieldValue={formik.setFieldValue}
                  />
                  <fieldset style={{ marginBottom: "5rem" }}>
                    <div className="col-12 d-flex justify-content-center">
                      <div className="bg-white col-11 cont">
                        <div
                          style={{ boxShadow: "0 1px 1px lightgray" }}
                          className="d-flex flexDir-column mt-2 col-12 elevation-2 mb-2 justify-content-between"
                        >
                          <p
                            style={{ color: "gray" }}
                            className=" p-1 m-0 custom-font-size"
                          >
                            <strong>New Customer</strong>
                          </p>
                          <div className="d-flex input-with-speech">
                            <input
                              id="voice-input-box"
                              type="text"
                              placeholder="Voice input displayed here..."
                              disabled
                            ></input>
                            <SpeechToText
                              inputId="voice-input-box"
                              style={{ marginBottom: "10px" }}
                            />

                            <img
                              onClick={() => setShowModal(true)}
                              src="/assets/import.png"
                              alt="import"
                              style={{
                                height: "25px",
                                width: "25px",
                                marginLeft: "12px",
                                cursor: "pointer",
                              }}
                            />
                          </div>
                        </div>
                        {showModal && (
                          <Modal
                            open={showModal}
                            onClose={() => setShowModal(false)}
                            aria-labelledby="csv-import-modal"
                            aria-describedby="csv-import-description"
                            style={{
                              display: "flex",
                              alignItems: "center",
                              justifyContent: "center",
                            }}
                          >
                            <div
                              style={{
                                backgroundColor: "white",
                                padding: "20px",
                                borderRadius: "8px",
                                width: "400px",
                                textAlign: "center",
                                boxShadow: "0px 4px 6px rgba(0, 0, 0, 0.1)",
                              }}
                            >
                              <CsvImport
                                closeModal={() => setShowModal(false)}
                              />
                              <button
                                onClick={() => setShowModal(false)}
                                style={{
                                  marginTop: "10px",
                                  backgroundColor: "gray",
                                  color: "white",
                                  border: "none",
                                  padding: "10px",
                                  borderRadius: "5px",
                                  cursor: "pointer",
                                }}
                              >
                                Close
                              </button>
                            </div>
                          </Modal>
                        )}

                        <div className="d-flex flex-wrap">
                          <div className="col-12 col-md-6 pl-0 pr-0">
                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left "
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Company Name</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="Company Name"
                                  name="companyname"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.companyname}
                                />
                                {formik.touched.companyname &&
                                  formik.errors.companyname && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.companyname}
                                    </span>
                                  )}
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Name</strong>
                                  <sup
                                    style={{
                                      color: "red",
                                      top: 0,
                                      fontSize: 15,
                                      lineHeight: 0,
                                      position: "relative",
                                      verticalAlign: "baseline",
                                    }}
                                  >
                                    *
                                  </sup>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 d-flex p-0 justify-content-end">
                                <div className="col-sm-6 pb-1 forms">
                                  <input
                                    type="text"
                                    placeholder="First Name"
                                    name="firstname"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.firstname}
                                  />
                                  {formik.touched.firstname &&
                                    formik.errors.firstname && (
                                      <span style={{ color: "red" }}>
                                        {formik.errors.firstname}
                                      </span>
                                    )}
                                </div>
                                <div className="col-sm-6 justify-content-end forms">
                                  <input
                                    type="text"
                                    placeholder="Last Name"
                                    name="lastname"
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                    value={formik.values.lastname}
                                  />
                                </div>
                                <div className="p-0 m-0 d-flex justify-content-center">
                                  {formik.touched.lastname &&
                                    formik.errors.lastname && (
                                      <span style={{ color: "red" }}>
                                        {formik.errors.lastname}
                                      </span>
                                    )}
                                </div>
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Status</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 ">
                                <select
                                  className="selectBox custom-select "
                                  name="status"
                                  id="status"
                                  value={formik.values.status}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                >
                                  {Enum.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.value}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>
                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Source</strong>
                                </label>
                              </div>
                              <div className="d-flex justify-content-between col-12 col-sm-8">
                                <div>
                                  <select
                                    name="leadsource"
                                    id="leadsource"
                                    className="selectBox custom-select"
                                    value={formik.values.leadsource}
                                    onChange={formik.handleChange}
                                    onBlur={formik.handleBlur}
                                  >
                                    {/* Render options from sourceData first if available */}
                                    {sourceData?.map((item, index) => (
                                      <option
                                        key={`source-${index}`}
                                        value={item}
                                      >
                                        {item}
                                      </option>
                                    ))}

                                    {/* Render remaining default options, avoiding duplicates */}
                                    {defaultSourceOptions
                                      .filter(
                                        (option) =>
                                          !sourceData ||
                                          !sourceData.includes(option),
                                      )
                                      .map((option, index) => (
                                        <option
                                          key={`default-${index}`}
                                          value={option}
                                        >
                                          {option}
                                        </option>
                                      ))}
                                  </select>
                                </div>
                                <div>
                                  <div className="h-100 ml-2">
                                    <button
                                      type="button"
                                      className="btn btn-primary w-100 h-100"
                                      style={{
                                        fontSize: "10px",
                                      }}
                                      onClick={() => setShowEventDialog(true)}
                                    >
                                      CREATE EVENT
                                    </button>
                                  </div>
                                  {showEventDialog && (
                                    <EventDialog
                                      setSourceData={setSourceData}
                                      onClose={() => setShowEventDialog(false)}
                                    />
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-6 pl-0 pr-0">
                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left "
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Best Way to Contact</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8">
                                <select
                                  name="bestwaycontact"
                                  id="bestwaycontact"
                                  className="selectBox custom-select "
                                  value={formik.values.bestwaycontact}
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                >
                                  <option value="Mobile">Mobile</option>
                                  {options.map((option) => (
                                    <option
                                      key={option.value}
                                      value={option.label}
                                    >
                                      {option.label}
                                    </option>
                                  ))}
                                </select>
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Mobile</strong>
                                  <sup
                                    style={{
                                      color: "red",
                                      top: 0,
                                      fontSize: 15,
                                      lineHeight: 0,
                                      position: "relative",
                                      verticalAlign: "baseline",
                                    }}
                                  >
                                    *
                                  </sup>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="Mobile"
                                  name="mobile"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.mobile}
                                />
                                {formik.touched.mobile &&
                                  formik.errors.mobile && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.mobile}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Phone</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="Phone"
                                  name="altphone"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.altphone}
                                />
                                {formik.touched.altphone &&
                                  formik.errors.altphone && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.altphone}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Email</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="Email"
                                  name="email"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.email}
                                />
                                {formik.touched.email &&
                                  formik.errors.email && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.email}
                                    </span>
                                  )}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 d-flex justify-content-center">
                      <div className="bg-white col-11 mt-3 cont">
                        <div className="d-flex justify-content-center">
                          <div
                            style={{ boxShadow: "0 1px 1px lightgray" }}
                            className=" col-12 m-1 mt-2  elevation-2 mb-3"
                          >
                            <p
                              style={{ color: "gray" }}
                              className=" p-1 m-0 custom-font-size"
                            >
                              <strong>Other Informations</strong>
                            </p>
                          </div>
                        </div>
                        {/* <div className="border col-11 mt-1 ml-5 "></div> */}

                        <div className="d-flex flex-wrap">
                          <div className="col-12 col-md-6 pl-0 pr-0 ">
                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Department</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="Department"
                                  name="department"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.department}
                                />
                                {formik.touched.department &&
                                  formik.errors.department && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.department}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Designation</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="Designation"
                                  name="designation"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.designation}
                                />
                                {formik.touched.designation &&
                                  formik.errors.designation && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.designation}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Category</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="Category"
                                  name="category"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.category}
                                />
                                {formik.touched.category &&
                                  formik.errors.category && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.category}
                                    </span>
                                  )}
                              </div>
                            </div>

                            {/* <div className="border col-12 ml-1 mb-3"></div> */}
                          </div>

                          <div className="col-12 col-md-6 pl-0 pr-0 ">
                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>ReportTo</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="ReportTo"
                                  name="reportTo"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.reportTo}
                                />
                                {formik.touched.reportTo &&
                                  formik.errors.reportTo && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.reportTo}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>GSTIN</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="GST Number"
                                  name="gstnumber"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.gstnumber}
                                />
                                {formik.touched.gstnumber &&
                                  formik.errors.gstnumber && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.gstnumber}
                                    </span>
                                  )}
                              </div>
                            </div>

                            <div className="col-12 col-sm-12 d-flex mb-2">
                              <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                <label
                                  htmlFor=""
                                  className="m-0 p-0 text-left"
                                  style={{ fontSize: 15 }}
                                >
                                  <strong>Website</strong>
                                </label>
                              </div>
                              <div className="col-12 col-sm-8 forms">
                                <input
                                  type="text"
                                  placeholder="https://abc.com/"
                                  name="website"
                                  onChange={formik.handleChange}
                                  onBlur={formik.handleBlur}
                                  value={formik.values.website}
                                />
                                {formik.touched.website &&
                                  formik.errors.website && (
                                    <span style={{ color: "red" }}>
                                      {formik.errors.website}
                                    </span>
                                  )}
                              </div>
                            </div>

                            {/* <div className="border col-12 ml-1 mb-3"></div> */}
                          </div>
                        </div>
                      </div>
                    </div>

                    <div className="col-12 d-flex justify-content-center">
                      <div className="bg-white col-11 mt-3 cont">
                        <div className="d-flex flex-wrap ">
                          <div className="col-12 col-md-6 pl-0 pr-0 ">
                            <div className="d-flex justify-content-center">
                              <div
                                style={{ boxShadow: "0 1px 1px lightgray" }}
                                className="col-12 m-1 mt-2 mb-4 elevation-2"
                              >
                                <p
                                  style={{ color: "gray" }}
                                  className=" p-1 m-0 custom-font-size"
                                >
                                  <strong>Billing Address</strong>
                                </p>
                              </div>
                            </div>
                            {/* <div className="border col-11 mt-1 ml-5 "></div> */}

                            <div className="d-flex flex-wrap ">
                              <div className="col-12 col-md-12 pl-0 pr-0 ">
                                <div className="col-12 col-sm-12 d-flex mb-2">
                                  <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                    <label
                                      htmlFor=""
                                      className="m-0 p-0 text-left"
                                      style={{ fontSize: 15 }}
                                    >
                                      <strong>Address1</strong>
                                    </label>
                                  </div>
                                  <div className="col-12 col-sm-8 forms">
                                    <input
                                      type="text"
                                      placeholder="Address1"
                                      name="billingAddress.address1"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={
                                        formik.values.billingAddress.address1
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="col-12 col-sm-12 d-flex mb-2">
                                  <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                    <label
                                      htmlFor=""
                                      className="m-0 p-0 text-left"
                                      style={{ fontSize: 15 }}
                                    >
                                      <strong>Address2</strong>
                                    </label>
                                  </div>
                                  <div className="col-12 col-sm-8 forms">
                                    <input
                                      type="text"
                                      placeholder="Address2"
                                      name="billingAddress.address2"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={
                                        formik.values.billingAddress.address2
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="col-12 col-sm-12 d-flex mb-2">
                                  <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                    <label
                                      htmlFor=""
                                      className="m-0 p-0 text-left"
                                      style={{ fontSize: 15 }}
                                    >
                                      <strong>City</strong>
                                    </label>
                                  </div>
                                  <div className="col-12 col-sm-8 forms">
                                    <input
                                      type="text"
                                      placeholder="City"
                                      name="billingAddress.city"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={formik.values.billingAddress.city}
                                    />
                                    {formik.touched.billingAddress &&
                                      formik.touched.billingAddress?.city &&
                                      formik.errors.billingAddress &&
                                      formik.errors.billingAddress.city && (
                                        <span style={{ color: "red" }}>
                                          {formik.errors.billingAddress.city}
                                        </span>
                                      )}
                                  </div>
                                </div>

                                <div className="col-12 col-sm-12 d-flex mb-2">
                                  <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                    <label
                                      htmlFor=""
                                      className="m-0 p-0 text-left"
                                      style={{ fontSize: 15 }}
                                    >
                                      <strong>Pincode</strong>
                                    </label>
                                  </div>
                                  <div className="col-12 col-sm-8 forms">
                                    <input
                                      type="text"
                                      placeholder="Pincode"
                                      name="billingAddress.pincode"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={
                                        formik.values.billingAddress.pincode
                                      }
                                    />
                                    {formik.touched.billingAddress &&
                                      formik.touched.billingAddress.pincode &&
                                      formik.errors.billingAddress &&
                                      formik.errors.billingAddress.pincode && (
                                        <span style={{ color: "red" }}>
                                          {formik.errors.billingAddress.pincode}
                                        </span>
                                      )}
                                  </div>
                                </div>

                                <div className="col-12 col-sm-12 d-flex mb-2">
                                  <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                    <label
                                      htmlFor=""
                                      className="m-0 p-0 text-left"
                                      style={{ fontSize: 15 }}
                                    >
                                      <strong>State</strong>
                                    </label>
                                  </div>
                                  <div className="col-12 col-sm-8 forms">
                                    <input
                                      type="text"
                                      placeholder="State"
                                      name="billingAddress.state"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={formik.values.billingAddress.state}
                                    />
                                    {formik.touched.billingAddress &&
                                      formik.touched.billingAddress.state &&
                                      formik.errors.billingAddress &&
                                      formik.errors.billingAddress.state && (
                                        <span style={{ color: "red" }}>
                                          {formik.errors.billingAddress.state}
                                        </span>
                                      )}
                                  </div>
                                </div>

                                <div className="col-12 col-sm-12 d-flex mb-2">
                                  <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                    <label
                                      htmlFor=""
                                      className="m-0 p-0 text-left"
                                      style={{ fontSize: 15 }}
                                    >
                                      <strong>Country</strong>
                                    </label>
                                  </div>
                                  <div className="col-12 col-sm-8 forms">
                                    <input
                                      type="text"
                                      placeholder="Country"
                                      name="billingAddress.country"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={
                                        formik.values.billingAddress.country
                                      }
                                    />
                                    {formik.touched.billingAddress &&
                                      formik.touched.billingAddress.country &&
                                      formik.errors.billingAddress &&
                                      formik.errors.billingAddress.country && (
                                        <span style={{ color: "red" }}>
                                          {formik.errors.billingAddress.country}
                                        </span>
                                      )}
                                  </div>
                                </div>

                                {/* <div className="border col-12 ml-1 mb-3"></div> */}
                              </div>
                            </div>
                          </div>
                          <div className="col-12 col-md-6 pl-0 pr-0 ">
                            <div className="d-flex col-md-12 justify-content-center">
                              <div
                                style={{ boxShadow: "0 1px 1px lightgray" }}
                                className="col-12 m-1 mt-2 mb-0  elevation-2"
                              >
                                <p
                                  style={{ color: "gray" }}
                                  className=" p-1 m-0 custom-font-size"
                                >
                                  <strong>Shipping Address</strong>
                                </p>
                              </div>
                            </div>
                            {/* <div className="border col-11 mt-1 ml-5 "></div> */}

                            <div className="checkbox-container">
                              <input
                                id="checkBox"
                                className="checkbox-custom"
                                name="copyBillingToShipping"
                                type="checkbox"
                                checked={formik.values.copyBillingToShipping}
                                onChange={formik.handleChange}
                              />
                              <label
                                htmlFor="checkBox"
                                className="checkbox-custom-label"
                              >
                                Same as billing address
                              </label>
                            </div>

                            <div className="d-flex flex-wrap ">
                              <div className="col-12 col-md-12 pl-0 pr-0 ">
                                <div className="col-12 col-sm-12 d-flex mb-2">
                                  <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                    <label
                                      htmlFor=""
                                      className="m-0 p-0 text-left"
                                      style={{ fontSize: 15 }}
                                    >
                                      <strong>Address1</strong>
                                    </label>
                                  </div>
                                  <div className="col-12 col-sm-8 forms">
                                    <input
                                      type="text"
                                      placeholder="Address1"
                                      name="shippingAddress.address1"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={
                                        formik.values.shippingAddress.address1
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="col-12 col-sm-12 d-flex mb-2">
                                  <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                    <label
                                      htmlFor=""
                                      className="m-0 p-0 text-left"
                                      style={{ fontSize: 15 }}
                                    >
                                      <strong>Address2</strong>
                                    </label>
                                  </div>
                                  <div className="col-12 col-sm-8 forms">
                                    <input
                                      type="text"
                                      placeholder="Address2"
                                      name="shippingAddress.address2"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={
                                        formik.values.shippingAddress.address2
                                      }
                                    />
                                  </div>
                                </div>

                                <div className="col-12 col-sm-12 d-flex mb-2">
                                  <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                    <label
                                      htmlFor=""
                                      className="m-0 p-0 text-left"
                                      style={{ fontSize: 15 }}
                                    >
                                      <strong>City</strong>
                                    </label>
                                  </div>
                                  <div className="col-12 col-sm-8 forms">
                                    <input
                                      type="text"
                                      placeholder="City"
                                      name="shippingAddress.city"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={formik.values.shippingAddress.city}
                                    />
                                    {formik.touched.shippingAddress &&
                                      formik.touched.shippingAddress.city &&
                                      formik.errors.shippingAddress &&
                                      formik.errors.shippingAddress.city && (
                                        <span style={{ color: "red" }}>
                                          {formik.errors.shippingAddress.city}
                                        </span>
                                      )}
                                  </div>
                                </div>

                                <div className="col-12 col-sm-12 d-flex mb-2">
                                  <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                    <label
                                      htmlFor=""
                                      className="m-0 p-0 text-left"
                                      style={{ fontSize: 15 }}
                                    >
                                      <strong>Pincode</strong>
                                    </label>
                                  </div>
                                  <div className="col-12 col-sm-8 forms">
                                    <input
                                      type="text"
                                      placeholder="Pincode"
                                      name="shippingAddress.pincode"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={
                                        formik.values.shippingAddress.pincode
                                      }
                                    />
                                    {formik.touched.shippingAddress &&
                                      formik.touched.shippingAddress.pincode &&
                                      formik.errors.shippingAddress &&
                                      formik.errors.shippingAddress.pincode && (
                                        <span style={{ color: "red" }}>
                                          {
                                            formik.errors.shippingAddress
                                              .pincode
                                          }
                                        </span>
                                      )}
                                  </div>
                                </div>

                                <div className="col-12 col-sm-12 d-flex mb-2">
                                  <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                    <label
                                      htmlFor=""
                                      className="m-0 p-0 text-left"
                                      style={{ fontSize: 15 }}
                                    >
                                      <strong>State</strong>
                                    </label>
                                  </div>
                                  <div className="col-12 col-sm-8 forms">
                                    <input
                                      type="text"
                                      placeholder="State"
                                      name="shippingAddress.state"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={
                                        formik.values.shippingAddress.state
                                      }
                                    />
                                    {formik.touched.shippingAddress &&
                                      formik.touched.shippingAddress.state &&
                                      formik.errors.shippingAddress &&
                                      formik.errors.shippingAddress.state && (
                                        <span style={{ color: "red" }}>
                                          {formik.errors.shippingAddress.state}
                                        </span>
                                      )}
                                  </div>
                                </div>

                                <div className="col-12 col-sm-12 d-flex mb-2">
                                  <div className="col-12 col-sm-4 justify-content-end text-right-lg">
                                    <label
                                      htmlFor=""
                                      className="m-0 p-0 text-left"
                                      style={{ fontSize: 15 }}
                                    >
                                      <strong>Country</strong>
                                    </label>
                                  </div>
                                  <div className="col-12 col-sm-8 forms">
                                    <input
                                      type="text"
                                      placeholder="Country"
                                      name="shippingAddress.country"
                                      onChange={formik.handleChange}
                                      onBlur={formik.handleBlur}
                                      value={
                                        formik.values.shippingAddress.country
                                      }
                                    />
                                    {formik.touched.shippingAddress &&
                                      formik.touched.shippingAddress.country &&
                                      formik.errors.shippingAddress &&
                                      formik.errors.shippingAddress.country && (
                                        <span style={{ color: "red" }}>
                                          {
                                            formik.errors.shippingAddress
                                              .country
                                          }
                                        </span>
                                      )}
                                  </div>
                                </div>

                                {/* <div className="border col-12 ml-1 mb-3"></div> */}
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-12 d-flex justify-content-center">
                      <div className="bg-white col-11 mt-3 cont">
                        <div className="d-flex justify-content-center">
                          <div>
                            <p
                              style={{ color: "gray" }}
                              className=" p-1 m-0 custom-font-size"
                            >
                              <strong>Notes</strong>
                            </p>
                          </div>
                        </div>
                        <div className="col-12 col-md-12 pl-0 pr-0 ">
                          <div className="col-12 col-sm-12 d-flex mb-2">
                            <div className="col-12 col-sm-12 forms">
                              <textarea
                                type="text"
                                id="notes"
                                name="notes"
                                rows={3}
                                placeholder="Notes"
                                onChange={formik.handleChange}
                                onBlur={formik.handleBlur}
                                value={formik.values.notes}
                              />
                            </div>
                          </div>

                          <div className="col-12 d-flex justify-content-end align-items-center gap-2 p-2 mt-2">
                            <button
                              type="button"
                              className="btn btn-sm btn-light border rounded px-4"
                              onClick={() => formik.resetForm()}
                            >
                              Cancel
                            </button>
                            <button
                              type="submit"
                              disabled={formik.isSubmitting}
                              className="btn btn-sm btn-primary rounded px-4"
                            >
                              {formik.isSubmitting ? "Saving..." : "Save"}
                            </button>
                          </div>

                          {/* <div className="border col-12 ml-1 mb-3"></div> */}
                        </div>
                      </div>
                    </div>
                  </fieldset>
                </form>
              )}
            </Formik>
          </div>

          <UserFooter />
          <ToastContainer
            position="top-center"
            autoClose={5000}
            hideProgressBar={false}
            newestOnTop={false}
            closeOnClick
            rtl={false}
            pauseOnFocusLoss
            draggable
            pauseOnHover
            theme="colored"
          />
        </div>
      </div>
    </>
  );
}
